import config from '@/commons/config';
import http from '@/commons/http';

const INSURANCE_URL = config.insuranceUrl;

/**
 * 获取货损原因列表
 * @param {*} data
 */
export const getDamageReasonList = (data = {}) => {
  return http.get(`${INSURANCE_URL}/common/damage_reason_list`, { params: data });
};

/**
 * 获取订单信息
 * @param {*} data
 */
export const getOrderInfo = (data = {}) => {
  return http.post(`${INSURANCE_URL}/common/order_info`, data);
};

/**
 * 获取货损情况列表
 * @param {*} data
 */
export const getCargoLoss = (data = {}) => {
  return http.get(`${INSURANCE_URL}/commonFacade/cargoLoss`, { params: data });
};

/**
 * 图片上传
 * @param {*} data
 */
export const imgUpload = (data = {}) => {
  return http.post(`${INSURANCE_URL}/commonFacade/imgUpload`, data);
};

/**
 *
 * @param {*} data
 */
export const getBaseInfo = (data = {}) => {
  return http.post(`${INSURANCE_URL}/commonFacade/baseInfo`, data);
};

/**
 * 获取司机手机号
 * @param {*} data
 */
export const getDriverPhoneNo = (data = {}) => {
  return http.post(`${INSURANCE_URL}/commonFacade/getPhoneNo`, data);
};

/**
 * 银行列表
 * @param {*} data
 */
export const getBankList = (data = {}) => {
  return http.get(`${INSURANCE_URL}/common/bank_list`, { params: data });
};

/**
 * 发送验证码，
 * @param {*} data
 */
export const sendCode = (data = {}) => {
  return http.post(`${INSURANCE_URL}/commonFacade/sendCode`, data);
};

/**
 * 验证码验证
 * @param {*} data
 */
export const checkCode = (data = {}) => {
  return http.post(`${INSURANCE_URL}/commonFacade/checkCode`, data);
};

/**
 * 获取司机银行卡信息
 * @param {*} data
 */
export const getDriverBankAccountInfo = (data = {}) => {
  return http.post(`${INSURANCE_URL}/insuranceCommonFacade/getBankAccountType`, data);
};

/**
 * 获取账户证件类型接口
 * @param {*} data
 */
export const getAccountsAttribute = (data = {}) => {
  return http.get(`${INSURANCE_URL}/insuranceCommonFacade/getAccountsAttribute`, { params: data });
};

/**
 * 校验token，
 * @param {*} data
 */
export const sendToken = (data = {}) => {
  return http.get(`${INSURANCE_URL}/commonFacade/checkToken`, { params: data });
};

/**
 * 责任人列表
 * @param {*} data
 */
export const getResponsibleList = (data = {}) => {
  return http.post(`${INSURANCE_URL}/claimWebFacade/getResponsibleInfo`, data);
};

/**
 * 打包类型公共分类
 * @param {*} data
 */
export const getSecondTypeApi = (data = {}) => {
  return http.get(`${INSURANCE_URL}/common/get_common_list`, { params: data });
};
